import { HttpInterceptorFn } from '@angular/common/http';
import { timeout } from 'rxjs/operators';
import { TIMEOUT_MS } from '../services/http/http-context';

/**
 * Applies a per-request timeout. The duration is read from the `TIMEOUT_MS`
 * context token (default: 15 s) so callers can opt into a longer window for
 * uploads or chunked operations without each service rebuilding the pipe.
 *
 * Sits inside the retry interceptor so each retry attempt gets its own
 * timeout window, not a single one shared across attempts.
 */
export const httpTimeoutInterceptor: HttpInterceptorFn = (req, next) => {
  const ms = req.context.get(TIMEOUT_MS);
  return next(req).pipe(timeout(ms));
};
